(() => {
  'use strict';
  const labelElement = document.getElementById('ZqLabels');
  const labels = labelElement ? JSON.parse(labelElement.textContent) : {};
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  let cartWork = null;
  let cartTimer;
  const pendingCart = new Map();
  let toastTimer;
  const showToast = (message) => {
    const toast = document.getElementById('ZqToast');
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 4500);
  };
  const openBag = () => { window.location.assign(root + 'cart'); };
  const replaceCartBody = (body, fresh) => {
    if (!body || !fresh) return;
    const active = body.contains(document.activeElement) ? document.activeElement : null;
    const activeId = active?.matches('[data-zq-cart-quantity]') ? active.id : null;
    const removeKey = active?.matches('[data-zq-remove]') ? active.closest('[data-zq-line]')?.dataset.zqLine : null;
    body.replaceChildren(...Array.from(fresh.childNodes));
    body.querySelectorAll('[data-zq-cart-quantity]').forEach(input => {
      const key = input.closest('[data-zq-line]')?.dataset.zqLine;
      if (pendingCart.has(key)) input.value = String(pendingCart.get(key));
    });
    if (activeId) document.getElementById(activeId)?.focus();
    if (removeKey && !body.querySelector('[data-zq-line="' + CSS.escape(removeKey) + '"]')) {
      (body.querySelector('[data-zq-remove],a,button') || document.querySelector('#ZqCart [data-zq-close]'))?.focus();
    }
  };
  const refreshCart = async () => {
    const results = await Promise.all([
      fetch(root + 'cart.js', {credentials: 'same-origin'}).then(r => {if (!r.ok) throw new Error(labels.cartError); return r.json();}),
      fetch(root + 'cart?section_id=zq-cart-drawer', {credentials: 'same-origin'}).then(r => {if (!r.ok) throw new Error(labels.cartError); return r.text();})
    ]);
    const cart = results[0];
    const fragment = new DOMParser().parseFromString(results[1], 'text/html');
    const freshBody = fragment.getElementById('ZqCartBody');
    const drawerBody = document.getElementById('ZqCartBody');
    if (!freshBody) throw new Error(labels.cartError);
    replaceCartBody(drawerBody, freshBody);
    document.querySelectorAll('[data-zq-cart-count]').forEach(el => {el.textContent = String(cart.item_count);});
    if (document.getElementById('ZqCartPageBody')) {
      const pageResponse = await fetch(root + 'cart?section_id=zq-cart-page', {credentials: 'same-origin'});
      const pageFragment = new DOMParser().parseFromString(await pageResponse.text(), 'text/html');
      const pageBody = pageFragment.getElementById('ZqCartPageBody');
      if (!pageResponse.ok || !pageBody) throw new Error(labels.cartError);
      replaceCartBody(document.getElementById('ZqCartPageBody'), pageBody);
    }
    document.dispatchEvent(new CustomEvent('cart:updated', {detail: {cart: cart}}));
    return cart;
  };
  const markCartBusy = (busy) => {
    document.querySelectorAll('.zq-cart-form').forEach(form => form.setAttribute('aria-busy', String(busy)));
    document.querySelectorAll('.zq-cart-form button[name="checkout"]').forEach(button => button.setAttribute('aria-busy', String(busy)));
  };
  const settleCart = () => {
    clearTimeout(cartTimer);
    if (cartWork) return cartWork;
    if (!pendingCart.size) return Promise.resolve(true);
    markCartBusy(true);
    cartWork = (async () => {
      let succeeded = true;
      while (pendingCart.size) {
        const changes = Array.from(pendingCart);
        pendingCart.clear();
        for (const [key, quantity] of changes) {
          try {
            const response = await fetch(root + 'cart/change.js', {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity})});
            const result = await response.json();
            if (!response.ok) throw new Error(result.description || result.message || labels.cartError);
          } catch (error) {
            succeeded = false;
            showToast(error.message || labels.cartError);
          }
        }
        if (!pendingCart.size) {
          try { await refreshCart(); }
          catch (error) { succeeded = false; showToast(error.message || labels.cartError); }
        }
      }
      return succeeded;
    })().finally(() => { cartWork = null; markCartBusy(false); });
    return cartWork;
  };
  const changeCart = (key, quantity, delayed = false) => {
    if (!Number.isSafeInteger(quantity) || quantity < 0) return;
    pendingCart.set(key, quantity);
    markCartBusy(true);
    clearTimeout(cartTimer);
    if (delayed) cartTimer = setTimeout(settleCart, 300);
    else return settleCart();
  };
  const readCartQuantity = (input, committed) => {
    const line = input.closest('[data-zq-line]');
    if (!line) return;
    if (input.value.trim() === '' || !input.validity.valid || !Number.isSafeInteger(Number(input.value))) {
      if (committed) {
        input.value = input.defaultValue;
        showToast(labels.cartError);
      }
      return;
    }
    if (Number(input.value) === Number(input.defaultValue) && !pendingCart.has(line.dataset.zqLine) && !cartWork) return;
    changeCart(line.dataset.zqLine, Number(input.value), !committed);
  };
  document.addEventListener('input', event => {
    const input = event.target.closest('[data-zq-cart-quantity]');
    if (input) readCartQuantity(input, false);
  });
  document.addEventListener('focusout', event => {
    const input = event.target.closest('[data-zq-cart-quantity]');
    if (input) readCartQuantity(input, true);
  });
  const setGalleryImage = (productRoot, url, alt, index, activeButton) => {
    const image = productRoot.querySelector('.zq-main-image');
    if (!image) return;
    image.removeAttribute('srcset');
    image.src = url;
    image.alt = alt || image.alt;
    productRoot.querySelectorAll('.zq-thumb').forEach(button => {button.setAttribute('aria-pressed', String(button === activeButton));});
    const counter = productRoot.querySelector('[data-zq-image-counter]');
    if (counter && index) {
      const total = counter.textContent.split('/').pop().trim();
      counter.textContent = index + ' / ' + total;
    }
  };
  document.addEventListener('submit', async (event) => {
    const cartForm = event.target.closest('.zq-cart-form');
    if (cartForm) {
      event.preventDefault();
      if (!cartForm.reportValidity()) return;
      cartForm.querySelectorAll('[data-zq-cart-quantity]').forEach(input => readCartQuantity(input, true));
      if (await settleCart() === false) return;
      if (event.submitter?.name === 'update') return;
      if (document.querySelector('.zq-cart-form')) window.location.assign(root + 'checkout');
      return;
    }
    const form = event.target.closest('.zq-add-form');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    if (!button || button.disabled) return;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    const status = form.querySelector('.zq-form-status');
    if (status) status.textContent = '';
    const body = new FormData(form);
    try {
      await settleCart();
      const response = await fetch(root + 'cart/add.js', {method:'POST',credentials:'same-origin',headers:{'Accept':'application/json'},body:body});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || labels.cartError);
      openBag();
    } catch (error) {
      if (status) status.textContent = error.message || labels.cartError;
      else showToast(error.message || labels.cartError);
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });
  document.addEventListener('click', (event) => {
    const step = event.target.closest('[data-zq-cart-step]');
    if (step) {
      const input = step.closest('[data-zq-line]').querySelector('[data-zq-cart-quantity]');
      const value = Math.max(0, (Number(input.value) || 0) + Number(step.dataset.zqCartStep));
      input.value = String(value);
      readCartQuantity(input, true);
      return;
    }
    const close = event.target.closest('[data-zq-close]');
    if (close) {const dialog=close.closest('dialog');if(dialog)dialog.close();return;}
    const bag = event.target.closest('[data-zq-cart-open]');
    if (bag && document.getElementById('ZqCart')) {event.preventDefault();openBag();return;}
    const continueLink = event.target.closest('.zq-cart-continue,.zq-cart-empty a');
    if (continueLink && (pendingCart.size || cartWork)) {
      event.preventDefault();
      const destination = continueLink.href;
      settleCart().then(() => window.location.assign(destination));
      return;
    }
    const remove = event.target.closest('[data-zq-remove]');
    if (remove) {event.preventDefault();const line=remove.closest('[data-zq-line]');if(line)changeCart(line.dataset.zqLine,0);return;}
    const quantity = event.target.closest('[data-zq-quantity]');
    if (quantity) {
      const input=quantity.closest('.zq-quantity').querySelector('input');
      input.value = String(Math.max(1, (parseInt(input.value,10)||1) + parseInt(quantity.dataset.zqQuantity,10)));
      input.dispatchEvent(new Event('change',{bubbles:true}));return;
    }
    const thumb = event.target.closest('[data-zq-image]');
    if (thumb) {setGalleryImage(thumb.closest('[data-zq-product]'),thumb.dataset.zqImage,thumb.dataset.zqAlt,thumb.dataset.zqIndex,thumb);return;}
    const galleryPreview = event.target.closest('[data-zq-zoom-source]');
    if (galleryPreview) {
      const dialog = document.getElementById('ZqZoom');
      const image = document.getElementById('ZqZoomImage');
      if (dialog && image) {image.src=galleryPreview.dataset.zqZoomSource;image.alt=galleryPreview.dataset.zqAlt || '';if(!dialog.open)dialog.showModal();}
      return;
    }
    const zoom = event.target.closest('[data-zq-zoom]');
    if (zoom) {
      const current=zoom.querySelector('.zq-main-image');
      const dialog=document.getElementById('ZqZoom');
      const zoomImage=document.getElementById('ZqZoomImage');
      if(current&&dialog&&zoomImage){zoomImage.src=current.src;zoomImage.alt=current.alt;if(!dialog.open)dialog.showModal();}
      return;
    }
    const sticky=event.target.closest('[data-zq-sticky-add]');
    if(sticky){const form=document.getElementById('ZqProductForm');if(form)form.requestSubmit();return;}
    const anchor = event.target.closest('a[href^="#"]');
    if(anchor && anchor.getAttribute('href').length>1){
      const target=document.getElementById(anchor.getAttribute('href').slice(1));
      if(target){event.preventDefault();target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});}
    }
  });
  document.addEventListener('change', (event) => {
    const sort=event.target.closest('[data-zq-sort]');
    if(sort){sort.form.requestSubmit();return;}
    const cartQuantity=event.target.closest('[data-zq-cart-quantity]');
    if(cartQuantity){readCartQuantity(cartQuantity,true);return;}
    const select=event.target.closest('[data-zq-variant]');
    if(!select)return;
    const option=select.selectedOptions[0];
    const productRoot=select.closest('[data-zq-product]');
    const available=option.dataset.available==='true';
    productRoot.querySelectorAll('[data-zq-price]').forEach(el=>{el.textContent=option.dataset.price;});
    productRoot.querySelectorAll('[data-zq-add-label]').forEach(el=>{el.textContent=available?labels.add:labels.soldOut;});
    productRoot.querySelectorAll('.zq-pdp-submit,[data-zq-sticky-add]').forEach(el=>{el.disabled=!available;});
    const availability=productRoot.querySelector('[data-zq-availability]');
    if(availability)availability.textContent=available?labels.available:labels.unavailable;
    if(option.dataset.image){const thumb=Array.from(productRoot.querySelectorAll('.zq-thumb')).find(el=>el.dataset.zqImage===option.dataset.image);setGalleryImage(productRoot,option.dataset.image,thumb?.dataset.zqAlt,thumb?.dataset.zqIndex,thumb);}
    const url=new URL(window.location.href);url.searchParams.set('variant',select.value);history.replaceState({},'',url);
  });
  document.querySelectorAll('dialog').forEach(dialog=>{dialog.addEventListener('click',event=>{if(event.target===dialog){const rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close();}});});
  document.querySelectorAll('.zq-header-search').forEach(details=>{details.addEventListener('toggle',()=>{if(details.open){const input=details.querySelector('input[type="search"]');if(input)input.focus();}});});
  window.addEventListener('pageshow', event => {
    if (event.persisted) settleCart().then(refreshCart).catch(() => {});
  });
  const productForm=document.getElementById('ZqProductForm');
  const sticky=document.querySelector('[data-zq-sticky]');
  if(productForm&&sticky&&'IntersectionObserver' in window){
    const observer=new IntersectionObserver(entries=>{const entry=entries[0];sticky.hidden=entry.isIntersecting||entry.boundingClientRect.top>0;},{threshold:0});
    observer.observe(productForm);
  }
})();

